import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyDeviceRequests = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyDeviceRequests);
};
